/**
 * Reserved Blocks Resource
 *
 * Global platform-reserved floor policy. `list` requires the platform-level
 * admin role — the server returns 403 otherwise (GET is NOT open, unlike
 * agentSettings.list). The blocks are seeded and read-only at runtime
 * (authz ADR-d5288).
 */

import type { HttpLayer } from '../http.js';

export interface ReservedBlock {
  key: string;
  title: string;
  body: string;
  enabled: boolean;
  ordering: number;
  updated_by?: string | null;
  created_at: string;
  updated_at: string;
}

export interface ReservedBlocksList {
  blocks: ReservedBlock[];
  max_floor_bytes: number;
  current_floor_bytes: number;
}

export class ReservedBlocksResource {
  constructor(private http: HttpLayer) {}

  private prefix = '/v1/platform';

  async list(): Promise<ReservedBlocksList> {
    return this.http.get(`${this.prefix}/reserved-blocks`);
  }
}
